import React, { useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import useDocumentTitle from '../../hooks/useDocumentTitle'
import './NotFoundPage.css'

const NotFoundPage = () => {
  useDocumentTitle('404')
  const navigate = useNavigate()
  const homeBtnRef = useRef(null)

  useEffect(() => {
    // Focus the primary action so keyboard users can hit Enter immediately
    // to escape the dead-end route.
    homeBtnRef.current?.focus({ preventScroll: true })
  }, [])

  const handleGoBack = () => {
    // window.history.back() is a no-op if the user landed on this route cold
    // (deep-link, refresh, external paste). Fall back to home so the button
    // never feels broken.
    if (window.history.length > 1) {
      navigate(-1)
    } else {
      navigate('/', { replace: true })
    }
  }

  return (
    <main className="nf-page has-grain" role="main" aria-labelledby="nf-title">
      <div className="nf-content">
        <div className="nf-code" aria-hidden>
          404
        </div>
        <h1 id="nf-title" className="nf-title fluid-headline">Lost a connection</h1>
        <p className="nf-subtitle fluid-subhead">
          This route doesn&apos;t exist (or it hasn&apos;t been wired up yet). Let&apos;s get you back.
        </p>
        <div className="nf-actions">
          <Link
            ref={homeBtnRef}
            to="/"
            className="nf-button nf-button--primary btn-magnetic"
          >
            Take me home
          </Link>
          <button
            type="button"
            className="nf-button nf-button--ghost"
            onClick={handleGoBack}
          >
            Go back
          </button>
        </div>
      </div>
    </main>
  )
}

export default NotFoundPage
